import React from 'react';
import { Grid } from 'semantic-ui-react';

import './PlatformAccountDetails.scss';

const PlatformAccountDetails = ({ balanceInfo }) => {
    const details = [
        { label: 'Account Balance', value: `$${balanceInfo?.account_balance || "00.00"}` },
        { label: 'SMS Reload Balance', value: `$${balanceInfo?.sms_balance || "00.00"}` },
        { label: 'Text Messaging Limit', value: '0/7000' }
    ];

    return (
        <Grid>
            {details.map((item, index) => (
                <Grid.Row key={index} textAlign='left' className='PlatformAccount__detail'>
                    <Grid.Column width={10} className='PlatformAccountDetails__label'>
                        {item.label}
                    </Grid.Column>
                    <Grid.Column width={6} className='PlatformAccountDetails__value'>
                        {item.value}
                    </Grid.Column>
                </Grid.Row>
            ))}
        </Grid>
    );
};

export default PlatformAccountDetails;
